<template>
  <b-row class="m-0">
    <b-col class="p-0 theme-col"  @click="toUrl">
      <img
        class="d-block img-fluid w-100 min-height"
        width="1024"
        height="490"
        :src="itemData.featureImgUrl"
        alt=""
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
name: "ImageLink",
props: ["itemData"],
mounted() {
  this.handelWidth();
},
methods: {
  handelWidth() {
    var container = document.getElementsByClassName("min-height");
    this.playerHeight = container[0].clientWidth / (16 / 9) + "px";
    for (var i = 0; i < container.length; i++) {
      container[i].style.height = this.playerHeight;
    }
  },
  toUrl() {
    this.$router.push({
      path: "/featuredetail",
      query: {
        featureId: this.itemData.featureId,
      },
    });
  },
},
};
</script>

<style lang='less' scoped>
@media screen and (max-width: 768px) {
.theme-col {
  // height: 235px;
  overflow: hidden;
  img {
    // height: 235px;
    width: 100%;
  }
}
}
@media screen and (min-width: 768px) {
.theme-col {
  cursor: pointer;
  width: 100%;
  height: auto;
  max-height: 817px;
  overflow: hidden;
  img {
    width: 100%;
    height: auto;
    max-height: 817px;
  }
}
}
</style>